module.exports = __webpack_public_path__ + "img/Quartier-du-Pont-Levis-a-Sete-900-600.2906fae1.png";